<template>
  <div>
    <h1 class="text-center">Import product display name</h1>
    <v-progress-circular
      v-if="isLoading"
      :size="70"
      :width="7"
      color="primary"
      indeterminate
      class="centered"
    ></v-progress-circular>
    <div v-else>
      <div class="pt-5">
        <p>
          Import data from file
          <a href="#" target="_blank" @click.prevent="downloadSampleFile"
            >Download sample file</a
          >
        </p>

        <div class="d-flex justify-content-start">
          <input
            type="file"
            class="form-control w-50"
            ref="importProductDisplayNameFile"
            @change="uploadImportFile"
            :disabled="isFileLoading"
          />
          <FileLoading extra-class="ml-5" v-if="isFileLoading" />
          <button v-else class="btn btn-outline-primary ml-5" @click="onSubmit">
            Save
          </button>
        </div>
      </div>
      <ListImportStatus />
      <v-dialog v-model="showDialog" width="500" persistent>
        <div class="content-dialog">
          <h5 class="p-5 text-center">{{ message }}</h5>
          <div class="text-center">
            <button class="btn-back" @click="showDialog = false">ปิด</button>
          </div>
        </div>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import ListImportStatus from "@/views/ImportProductDisplayName/ListImportStatus";
import FileLoading from "components/Loading/FileLoading.vue";
import ProductDisplayNameService from "services/api/productDisplayName.service";
import PresignedUploadUrlService from "services/api/presignedUploadUrl.service";

export default {
  components: { FileLoading, ListImportStatus },
  data() {
    return {
      fileKey: null,
      originalFileName: null,
      isLoading: false,
      isFileLoading: false,
      message: "",
      showDialog: false,
    };
  },
  methods: {
    downloadSampleFile() {
      try {
        window.open(
          process.env.VUE_APP_HOST_API +
            "static/sample/sampleProductDisplayName.xlsx"
        );
      } catch (error) {
        console.log("Error: ", error);
      }
    },
    uploadImportFile() {
      const importFile = this.$refs.importProductDisplayNameFile.files[0];
      this.originalFileName = importFile.name;
      this.getPresignURL(importFile);
    },
    async getPresignURL(file) {
      this.isFileLoading = true;
      await PresignedUploadUrlService.getS3SignUrl(
        "importProductDisplayName",
        file
      )
        .then((res) => {
          const data = res.data;
          this.fileKey = data.key;
          this.updatePhotoToS3(data.presignedUrl, file);
        })
        .catch((err) => {
          console.log("Error: ", err.response);
        });
    },
    async updatePhotoToS3(url, file) {
      await PresignedUploadUrlService.pushProfilePhotoToS3(url, file);
      this.isFileLoading = false;
    },
    async onSubmit() {
      this.isLoading = true;
      const formData = new FormData();
      if (this.fileKey) {
        formData.append("fileKey", this.fileKey);
      }
      if (this.originalFileName) {
        formData.append("originalFileName", this.originalFileName);
      }
      this.resetFile();
      await this.importProductDisplayNameFile(formData);
    },
    async importProductDisplayNameFile(body) {
      await ProductDisplayNameService.uploadProductDisplayName(body)
        .then((res) => {
          this.isLoading = false;
          const data = res.data;
          if (data.message) {
            this.message = data.message;
            this.showDialog = true;
          }
        })
        .catch((err) => {
          this.isLoading = false;
          console.log("Error: ", err.response);
          const errRes = err.response;
          this.message = errRes.data.message;
          this.showDialog = true;
        });
    },
    resetFile() {
      this.fileKey = null;
      this.originalFileName = null;
    },
  },
};
</script>

<style lang="scss" scoped>
.centered {
  position: absolute;
  top: 45%;
  left: 50%;
}
</style>
